import { forwardRef } from "react";
import Portal from "./Layout/Portal";
import { useApp } from "../AppProvider";
import { AnimatePresence, motion } from "framer-motion";
import styled from "@emotion/styled";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { Container } from "./Layout/Container";

const Main = styled(motion.div)(() => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "#fff",
  zIndex: 1000,
  display: "flex",
  flexDirection: "column",
  overflowX: "hidden",
  overflowY: "auto",
  padding: "3rem 1rem 1rem 1rem",
  fontFamily: "Raleway",
}));

const CloseButton = styled("button")(() => ({
  backgroundColor: "transparent",
  border: "none",
  cursor: "pointer",
  padding: "1rem",
  position: "absolute",
  top: "1rem",
  right: "1rem",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  "& svg": {
    width: 20,
    height: 20,
    fill: "#000",
  },
}));

const Close = styled(motion.button)(() => ({
  backgroundColor: "#000",
  color: "#fff",
  fontWeight: "bold",
  fontSize: 16,
  textAlign: "center",
  border: "none",
  cursor: "pointer",
  padding: "14px 42px",
  borderRadius: 20,
}));

const Title = styled("h1")(() => ({
  fontSize: 40,
  fontWeight: 400,
  margin: "0 0 1rem 0",
}));

export const Impressum = forwardRef<HTMLDivElement, unknown>((props, ref) => {
  const app = useApp();

  return (
    <Portal wrapperId={"datenschutz"}>
      <AnimatePresence>
        {app.impressumOpen && (
          <Main
            ref={ref}
            initial={{ y: "100%" }}
            animate={{ y: 0 }}
            exit={{ y: "100%" }}
            transition={{
              duration: 0.4,
              stiffness: 100,
              damping: 20,
              type: "spring",
            }}
          >
            <Container>
              <CloseButton
                onClick={() => app.setImpressumOpen(false)}
                type={"button"}
              >
                <XMarkIcon />
              </CloseButton>
              <Title>Impressum</Title>
              <p>
                Diese Webseite wird von der Centre Films GmbH & Co. KG (Meißner
                Str. 21, 01445 Radebeul) betrieben.
              </p>
              <p>
                <b>Kontakt</b>
                <br />
                Telefon: +49 173 380 28 00
                <br />
                E-Mail: info@centrefilms.de
                <br />
                Mo-Fr 9:00-18:00 Uhr
              </p>
              <p>
                Bei einer Kontaktaufnahme per E-Mail erklären Sie sich mit der
                Verarbeitung Ihrer persönlichen Daten gemäß unserer
                Datenschutzerklärung einverstanden.
              </p>
              <p>
                <b>Umsatzsteuer-ID</b> <br />
                <br />
                Umsatzsteuer-Identifikationsnummer gemäß §27a
                Umsatzsteuergesetz:
                <br />
                209/2F220/2F11907
              </p>
              <p>
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV: Centrefilms
                GmbH & Co.KG, Meißner Strasse 21, 01445 Radebeul
              </p>
              <p style={{ fontSize: 18 }}>
                <b>HAFTUNGSAUSCHLUSS</b>
              </p>
              <p>
                <b>Haftung für Inhalte</b>
                <br />
                <br />
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
                Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
                können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter
                sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen
                Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
                bis 10 TMG sind wir als Diensteanbieter jedoch nicht
                verpflichtet, übermittelte oder gespeicherte fremde
                Informationen zu überwachen oder nach Umständen zu forschen, die
                auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur
                Entfernung oder Sperrung der Nutzung von Informationen nach den
                allgemeinen Gesetzen bleiben hiervon unberührt. Eine
                diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                Kenntnis einer konkreten Rechtsverletzung möglich. Bei
                Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
                diese Inhalte umgehend entfernen.Haftung für Links.
                <br />
                <br /> Unser Angebot enthält Links zu externen Webseiten
                Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
                können wir für diese fremden Inhalte auch keine Gewähr
                übernehmen. Für die Inhalte der verlinkten Seiten ist stets der
                jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
                verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf
                mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren
                zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
                inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
                konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar.
                Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
                Links umgehend entfernen.
                <br />
                <br /> <b>Urheberrecht</b>
                <br />
                <br /> Die durch die Seitenbetreiber erstellten Inhalte und
                Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht.
                Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
                Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
                schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                Downloads und Kopien dieser Seite sind nur für den privaten,
                nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf
                dieser Seite nicht vom Betreiber erstellt wurden, werden die
                Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
                Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
                Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
                entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen
                werden wir derartige Inhalte umgehend entfernen.
              </p>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 20,
                }}
              >
                <Close
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  type={"button"}
                  onClick={() => app.setImpressumOpen(false)}
                >
                  Schließen
                </Close>
              </div>
            </Container>
          </Main>
        )}
      </AnimatePresence>
    </Portal>
  );
});
